import { firestore } from '@/firebase'
import api from '@/api'

function get (success, error) {
  return api.auth.get(user => user ? firestore.collection('users').doc(user.uid) : null, success, error)
}

function sync (success, error) {
  const callback = {
    updated: success
  }
  return api.auth.subscribe(user => user ? firestore.collection('users').doc(user.uid) : null, callback, success, error)
}

export default {
  get,
  sync
}



// WEBPACK FOOTER //
// ./src/api/profiles.js